import { createSlice } from '@reduxjs/toolkit'
const img1 = "/assets/images/experiences/passport.jpg";
const img2 = "/assets/images/experiences/agent.png";
const textng = '/assets/experience/textng.png';
const uxtech = '/assets/experience/uxtech.png';

const experienceSlice = createSlice({
    name: 'experiences',
    initialState: {
      payload: [
        {
          img: uxtech,
          description: 'UXTECH is a self owned side hustle Telecommunication Startup. I served as the Chief Technology Officer and responsible for choosing tech stack for app developments. ',
          role: 'Chief Technology Officer.',
          company: 'UXTECH (UX-ELITE TECHNOLOGIES)',
          date: 'Sept-2023 to Date'
        },
        {
          img: textng,
          description: 'Textng Comms is a Telecommunication company that offers SMS, Voice, USSD and other related telecom services.',
          role: 'Full STack Software Developer (Majorly Frontend).',
          company: 'Textng Communications',
          date: 'March-2022 to Nov-2023'
        },
        {
          img: img1,
          description: 'o4WIN is a private analytical company.',
          role: 'Full STack Software Developer (Majorly Backend).',
          company: 'o4WIN',
          date: 'April-2022 to May-2023'
        },
        
          
      ]
    }
    ,
    reducers: {
        experiences: (state, action) => {
            state.experiences = action.payload;
        }
    }
})

export const {experiences} = experienceSlice.actions;
export default experienceSlice.reducer;
